import { render } from "./ModuleLayoutBlockEditable.vue?vue&type=template&id=21b0a413"
import script from "./ModuleLayoutBlockEditable.vue?vue&type=script&lang=js"
export * from "./ModuleLayoutBlockEditable.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__